import {Component, inject} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {BtbRolesCheckService} from "../../../../components/rolesCheck/btb-roles-check.service";

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styles: [`h2, p{font-family: "Montserrat", system-ui, sans-serif !important;}`]
})
export class DeleteAccountComponent {
  rolesCheck = inject(BtbRolesCheckService);
  canAccess = false;

  constructor(public dialog: MatDialogRef<DeleteAccountComponent>) {}

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }
  }

  goBack(): void {
    this.dialog.close(false);
  }
  onDelete(): void {
    this.dialog.close(true);
  }

}
